export const yacanConfig = {
  connection: {
    title: "Connessione YACAN",
    subtitle:
      "Collega il tuo account YACAN per gestire l'accesso dei tuoi ospiti con le tue serrature.",
    connected: "Account collegato",
    notConnected: "Non collegato",
    info:
      "Quando fai clic su <b>Connetti con YACAN</b> si aprirà una finestra per accedere e autorizzare l'accesso. La connessione viene salvata per l'intero account e utilizzata in tutte le tue strutture.",
    connect: "Connetti con YACAN",
    waiting: "In attesa di autorizzazione...",
    connectedTitle: "Account YACAN collegato",
    authActive: "Autorizzazione attiva",
    reauthorize: "Riautorizza",
    reauthorizeTitle: "Autorizza di nuovo",
    disconnect: "Disconnetti",
  },
  locks: {
    title: "Serrature per questa struttura",
    subtitle: "Seleziona le serrature YACAN che si applicano a <b>questa struttura</b>.",
    selectedCount: "{count} selezionate",
    noneFound: "Nessuna serratura trovata nel tuo account YACAN.",
    refresh: "Aggiorna",
    placeholder: "Seleziona le serrature…",
    summary: "{count} serrature selezionate",
    empty: "Nessuna serratura selezionata",
    lockFallback: "Serratura {id}",
    save: "Salva le serrature per questa struttura",
    saving: "Salvataggio...",
  },
  assign: {
    title: "Assegnazione (PMS)",
    subtitle: "Assegna ogni serratura a <b>Porta principale</b>, <b>Unità</b> o <b>Cancello</b>.",
    assignedCount: "{count} assegnate",
    info:
      "Con YACAN, <b>l'accesso degli ospiti è gestito da YACAN</b> in base alla prenotazione: qui non viene generato alcun PIN. Quando una prenotazione viene confermata, si sincronizza automaticamente con YACAN.",
    lockFallback: "Serratura {id}",
    assignmentLabel: "Assegnazione",
    typeNone: "Non assegnata",
    typeCommon: "Porta principale (condivisa)",
    typeUnit: "Porta dell'appartamento",
    typeGate: "Cancello / Garage",
    unitLabel: "Unità / Alloggio",
    unitPlaceholder: "Seleziona un'unità",
    unitFallback: "Unità {id}",
    save: "Salva assegnazione",
    saving: "Salvataggio...",
  },
  msg: {
    connectStartError: "Impossibile avviare la connessione con YACAN",
    popupBlocked: "Consenti le finestre pop-up per connetterti con YACAN.",
    connectError: "Errore durante la connessione con YACAN",
    connectSuccess: "Account YACAN collegato correttamente",
    connectFailed: "Impossibile connettersi con YACAN",
    disconnectConfirm:
      "Disconnettere il tuo account YACAN? Le prenotazioni non si sincronizzeranno più con YACAN.",
    disconnectSuccess: "Account YACAN disconnesso",
    disconnectError: "Impossibile disconnettere",
    locksLoadError: "Impossibile caricare le serrature",
    locksLoadError2: "Errore durante il caricamento delle serrature YACAN",
    selectAtLeastOne: "Seleziona almeno una serratura.",
    lockDefaultName: "Serratura YACAN",
    locksSaved: "Serrature salvate per questa struttura",
    locksSaveError: "Impossibile salvare le serrature",
    saveError: "Errore durante il salvataggio",
    selectUnitForApartment: "Seleziona l'unità per le serrature di tipo 'Porta dell'appartamento'.",
    assignSaved: "Assegnazione salvata correttamente",
    assignSaveError: "Impossibile salvare l'assegnazione",
    assignSaveError2: "Errore durante il salvataggio dell'assegnazione",
  },
};
